import axios from '@/util/axios';
import common from '../common'

export default {
    list(params) {
        return common.get('/rocheManage/sys/user/list',params);
    },

    add(params) {
        return common.post('/rocheManage/sys/user/add',params);
    },

    edit(params) {
        return common.put('/rocheManage/sys/user/edit',params);
    },

    delete(params) {
        return common.delete('/rocheManage/sys/user/delete',params);
    },

    deleteBatch(params) {
        return common.delete('/rocheManage/sys/user/deleteBatch',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/sys/user/exportXls', params, {responseType: 'blob'});
    },

    importUrl4Excel() {
      return common.getBaseURL() + '/rocheManage/sys/user/importExcel';
    },
}



// WEBPACK FOOTER //
// ./src/api/sysmanagement/privilege.js